import { render, staticRenderFns } from "./LifePage2.vue?vue&type=template&id=e844fb80&scoped=true"
import script from "./LifePage2.vue?vue&type=script&lang=js"
export * from "./LifePage2.vue?vue&type=script&lang=js"
import style0 from "./LifePage2.vue?vue&type=style&index=0&id=e844fb80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e844fb80",
  null
  
)

export default component.exports